import React from 'react'

import { FwIcon } from '@fourthwall/icons'
import { isWebView } from '@fourthwall/utils'

import { Icon } from '../Icon'
import * as S from './styled'

export const SuspenseFallback = () => {
  if (isWebView()) return <div />

  return (
    <S.Container>
      <Icon component={FwIcon} height={60} />
    </S.Container>
  )
}
